import React from 'react';
import { ContactThankYouMolecule } from '../../molecules';
import { PartnerFormProps } from './partner-form.props';
import { usePartnerFormEffect } from './partner-form.effect';
import { PartnerFormQuestion } from '../../../enums';

export const PartnerFormOrganism = (props: PartnerFormProps) => {
  const { members, questions, isValid, onSubmit, success, error } =
    usePartnerFormEffect();

  const question = questions[PartnerFormQuestion.PARTNER_CONTACT_REASONS]
    ? questions[PartnerFormQuestion.PARTNER_CONTACT_REASONS]
    : undefined;

  return (
    <div
      data-cy="contact-us-form"
      className="flex justify-center md:items-center w-full lg:mx-auto lg:max-w-screen-lg h-full bg-white overflow-y-auto"
    >
      {!success && (
        <div
          className="flex flex-col items-center h-full p-5 w-11/12 lg:w-4/5"
          id="contactUsForm"
        >
          <h2 className="text-center py-4 text-waldo-blue">{props.title}</h2>
          <form className="w-full" onSubmit={onSubmit}>
            {error && (
              <div
                className={`text-waldo-tangerine text-sm font-medium text-center`}
              >
                {error.includes(
                  'Unique constraint failed on the constraint: `Contact_email_key'
                )
                  ? 'You are already subscribed to our mailing list.'
                  : error}
              </div>
            )}
            <div className="relative pt-3.5 mb-4">
              {!members.name.isClean && !members.name.isValid && (
                <span className="text-waldo-tangerine text-sm absolute top-0 right-0 font-medium">
                  {members.name.errors[0]}
                </span>
              )}
              <label className="hidden">FULL NAME*</label>
              <input
                type="text"
                className={`mt-2.5 border-solid border ${
                  !members.name.isClean && !members.name.isValid
                    ? 'input-error-border'
                    : 'input-border'
                }`}
                placeholder="FULL NAME*"
                aria-label="NAME*"
                name={members.name.name}
                onChange={(e) => members.name.onChange(e.target.value)}
                onFocus={() => members.name.onFocus()}
                onBlur={() => members.name.onBlur()}
                value={members.name.value as string}
              />
            </div>

            <div className="relative pt-3.5 mb-4">
              {!members.email.isClean && !members.email.isValid && (
                <span className="text-waldo-tangerine text-sm absolute top-0 right-0 font-medium">
                  {members.email.errors[0]}
                </span>
              )}
              <label className="hidden">EMAIL*</label>
              <input
                type="text"
                className={`mt-2.5 border-solid border ${
                  !members.email.isClean && !members.email.isValid
                    ? 'input-error-border'
                    : 'input-border'
                }`}
                placeholder="EMAIL*"
                aria-label="EMAIL*"
                name={members.email.name}
                onChange={(e) => members.email.onChange(e.target.value)}
                onFocus={() => members.email.onFocus()}
                onBlur={() => members.email.onBlur()}
                value={members.email.value as string}
              />
            </div>

            <div className="relative pt-3.5 mb-4">
              {!members.practice.isClean && !members.practice.isValid && (
                <span className="text-waldo-tangerine text-sm absolute top-0 right-0 font-medium">
                  {members.practice.errors[0]}
                </span>
              )}
              <label className="hidden">PRACTICE*</label>
              <input
                type="text"
                className={`mt-2.5 border-solid border ${
                  !members.practice.isClean && !members.practice.isValid
                    ? 'input-error-border'
                    : 'input-border'
                }`}
                placeholder="NAME OF THE PRACTICE*"
                aria-label="PRACTICE*"
                name={members.practice.name}
                onChange={(e) => members.practice.onChange(e.target.value)}
                onFocus={() => members.practice.onFocus()}
                onBlur={() => members.practice.onBlur()}
                value={members.practice.value as string}
              />
            </div>
            {question && (
              <div
                className="mb-8 mt-8 lg:mt-10 w-full lg:w-max lg:max-w-2xl lg:mx-auto"
                id="AmbassadorForm"
              >
                <p className="text-waldo-blue block mb-1.5  lg:mb-5 font-normal">
                  {question.phrase}
                </p>
                <div className="flex flex-col lg:flex-row flex-wrap w-full  justify-start lg:justify-center">
                  {question.choices!.map((choice, choiceIndex) => (
                    <div
                      className="w-full lg:w-2/5 lg:max-w-md"
                      key={choiceIndex}
                    >
                      <label className="w-full flex flex-row my-2 relative cursor-pointer">
                        <input
                          type="checkbox"
                          name="answers[]"
                          value={choice.value as number}
                          onChange={() => question.onChange(choice.value)}
                          onFocus={() => question.onFocus()}
                          onBlur={() => question.onBlur()}
                          className="w-8"
                        />
                        <span className="text-waldo-blue text-base font-normal leading-7 -mt-0.5 lg:-mt-1">
                          {choice.label}
                        </span>
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            )}
            <div className="flex justify-center mt-7 mb-10">
              <button
                disabled={!isValid}
                className="button btn-cta w-full lg:w-72 bg-waldo-tangerine border-waldo-tangerine disabled:cursor-default disabled:transition-none disabled:opacity-50 font-waldo-header font-light"
                type="submit"
              >
                {props.buttonLabel}
              </button>
            </div>
          </form>
        </div>
      )}

      {success && (
        <div
          className={`flex w-4/5 mx-auto text-center flex-col justify-center h-screen items-center`}
        >
          <ContactThankYouMolecule
            desc="Your information has been submitted and someone will reach out to you
        shortly."
            title="Thank you"
          />
        </div>
      )}
    </div>
  );
};
